// extracted by mini-css-extract-plugin
module.exports = {"isSimpleCard":"styles_isSimpleCard__vU_ru"};